import { render, staticRenderFns } from "./DrawerStack.vue?vue&type=template&id=6fe46c9c"
import script from "./DrawerStack.vue?vue&type=script&lang=js"
export * from "./DrawerStack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports